export default __webpack_public_path__ + "media/images/brands/demo/logos/logo-light-165x76-186f63466c71ca839f8653f7ba7a1306.png";